import React from 'react';
import PageBanner from "@/components/pageBanner";
import {MailIcon, MapPin, Phone} from "lucide-react";
import {Link} from "react-router-dom";
import Paths from "../constants/Paths";
import {ReactComponent as Messenger} from '../assets/images/icons/messenger.svg';
import {ReactComponent as Discord} from "../assets/images/icons/discord.svg";
import {ReactComponent as Facebook} from "../assets/images/icons/facebook.svg";
import {ReactComponent as Instagram} from "../assets/images/icons/instagram.svg";
import {ReactComponent as Youtube} from "../assets/images/icons/youtube.svg";
import {ReactComponent as Tiktok} from "../assets/images/icons/tiktok.svg";
import {ReactComponent as Linkedin} from "../assets/images/icons/linkedin.svg";
import {ReactComponent as Twitterx} from "../assets/images/icons/twitterx.svg";
import {ReactComponent as Telegram} from "../assets/images/icons/telegram.svg";
import Logo from "../assets/images/logo.svg";
import {Input} from "@/components/ui/input";
import {Button} from "@/components/ui/button";
import ContactForm from "@/components/contactForm";

const Contact = () => {
    return (
        <>
            <PageBanner title="Contact" slug="contact"/>
            <section className="dark-bg-with-gradients contact-page py-14">
                <div className="generic-container">
                    <div className="left-side">
                        <div className="flex flex-col items-start xs:col-span-2">
                            <img src={Logo} alt="Opis obrazu" className="mb-4" style={{maxWidth: '180px'}}/>
                            <div className="flex items-center mb-4 text-white">
                                <MapPin className="mr-2"/>
                                <div>
                                    <p>Locked Trade LLC</p>
                                    <p>New York Office</p>
                                    <p>40 Wall St. 28th Floor</p>
                                    <p>New York City, NY 10005</p>
                                    {/*
                                    <p>---</p>
                                    <p>Warsaw Office</p>
                                    <p>FlixCash</p>
                                    <p>Chmielna 73 B suite 14</p>
                                    <p>00-801 Warszawa</p>
                                    */}
                                </div>
                            </div>
                            <Link to="mailto:office@lockedtrade.com"
                                  className="flex items-center mb-4 contact-link-item">
                                <MailIcon className="mr-2"/>
                                <p>office@lockedtrade.com</p>
                            </Link>
                            {/*
                            <Link to="tel:+16467848259" className="flex items-center mb-4 contact-link-item">
                                <Phone className="mr-2"/>
                                <p className="text-nowrap">+1 646 784 8259</p>
                            </Link>
                            */}
                            <div className="flex flex-row flex-wrap gap-2 mt-2" style={{display: 'none'}}>
                                <Link to={Paths.DISCORD} className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Discord alt="discord"/>
                                    </div>
                                </Link>
                                <Link to={Paths.INSTAGRAM} target="_blank" className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Instagram alt="instagram"/>
                                    </div>
                                </Link>
                                {/*
                                <Link to={Paths.YOUTUBE} target="_blank" className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Youtube alt="youtube"/>
                                    </div>
                                </Link>
                                */}
                                {/*
                                <Link to={Paths.FACEBOOK} className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Facebook alt="facebook"/>
                                    </div>
                                </Link>
                                */}
                                <Link to="" className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Tiktok alt="tiktok"/>
                                    </div>
                                </Link>
                                <Link to="" className="contact-social-item-two">
                                    <div className="social-icon-container">
                                        <Twitterx alt="x"/>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="right-side">
                        <ContactForm/>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact;

